import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { formatAge, getGenderEmoji } from "../../../../utils/utils";
import { useTranslation } from "react-i18next";

function PatientPersonalTitleDetails({
  PatientsData,
  className,
  notTimestamp = true,
}: {
  PatientsData: any;
  className?: string;
  notTimestamp?: boolean;
}) {
  const UserInfo = useSelector((state: RootState) => state.registration);

  const { t } = useTranslation();
  return (
    <div className="flex-1">
      <h2 className="text-primary-textFont mb-1 text-lg font-bold">
        {PatientsData?.FullName}
      </h2>
      <p className={`text-body-text text-sm ${className}`}>
        {getGenderEmoji(PatientsData?.Gender) +
          " " +
          t(PatientsData?.Gender?.trim().toLocaleLowerCase() || "")}
        {" • "}
        {PatientsData?.Birthday && (
          <span>
            {formatAge(PatientsData?.Birthday, notTimestamp)} {t("years_old")}
          </span>
        )}
        {" • "}
        <span dir="ltr">
          {UserInfo.userDetails.Country?.Code}-{PatientsData?.PhoneNumber}
        </span>
      </p>
    </div>
  );
}

export default PatientPersonalTitleDetails;
